<template>
  <div  v-if="tagList.length==0">
    <span>-</span>
  </div>
  <div class="Tags" style="font-size:0;" v-else>
      <span 
        v-for="(item,index) in tagList" 
        :key="index"
        :class="{
          comStatus: true,
          comWarn: checkEntstatus(item.tagText),
          comGreen: ['005'].includes(item.categoryCode),
          comBlue: ['003', '004', '006', '008','009'].includes(item.categoryCode),
          comOrange: ['007'].includes(item.categoryCode),
          comTaxation: ['002'].includes(item.categoryCode)
      }"
      >{{ item.tagText }}</span>
  </div>
</template>
<script>
import { isEmpty } from '../../common/utils';
  export default {
    props: ['row','dimensionShow'],
    data() {
      return {
        tagList : [],
      };
    },
    watch:{
      row(val){
        this.getTags();
      },
    },
    methods:{
      getkeys( index, item ) {
        return index + item;
      },
      getTags(){
        this.tagList = [];
        if( this.row && this.row.length ) {
          this.row.map( ( item ) => {
            let tagText = item.tagName || item.tag_name;
            if( tagText ) {
              let tagTextArr = tagText.split( '-' );
              tagText = tagTextArr.length > 1 ? tagTextArr[ 1 ] : tagTextArr[ 0 ];
              item[ 'tagText' ] = tagText;

              this.tagList.push( item );
            }
          });
        }
      }
    },
    created(){
      this.getTags();
    },
  };
</script>
<style lang="scss" scoped>
 .Tags span{
    border-radius: 2px;
    font-size: 11px;
    font-weight: normal;
    // min-width: 38px;
    height: 22px;
    line-height: 18px;
    text-align: center;
    margin:2px;
    padding:1px 6px;
    display: inline-block;
  }
 span.comStatus{
   color: #66bb6a;
   border: 1px solid #66bb6a;
 }
 span.comWarn{
   color: #ec6459;
   border: 1px solid #ec6459;
 }
 span.comDimension{
   color: #67aef5;
   border: 1px solid #67aef5;
 }
 span.comIpo{
   color: #fe9e16;
   border: 1px solid #fe9e16;
 }
 //上市
  span.comIpo{
   color: #f49025;
   border: 1px solid #f49025;
 }
 //桔子
 span.comOrange{
   color: #f79f03;
   border: 1px solid #f79f03;
 }
 //高新企业
 span.comHigh{
   color: #41bfbf;
   border: 1px solid #41bfbf;
 }
 span.comBlue {
  color: #108ee9;
  border: 1px solid #108ee9;
}
// '005'
span.comGreen {
  color: #13c2c2;
  border: 1px solid #13c2c2;
}
// '002'
span.comTaxation {
  color: #aa7db4;
  border: 1px solid #aa7db4;
}
</style>





// WEBPACK FOOTER //
// src/components/global/tags.vue